import React, { useState } from 'react';

const faqData = [
  {
    category: 'Kategorija 1: Održivi ekonomski razvoj i partnerstva',
    questions: [
      {
        q: 'Šta ako nemamo precizne statističke podatke za broj zaposlenih ili MSP-a?',
        a: 'Preporučuje se korištenje internih izvora poput godišnjih izvještaja, podataka iz lokalnih službi i procjena općinskog vijeća.'
      },
      {
        q: 'Kako da izračunamo „% rasta“?',
        a: 'Formula: (Vrijednost u 2025 – Vrijednost u 2023) ÷ Vrijednost u 2023 × 100. Npr. (9350 – 8500) ÷ 8500 × 100 = 10%.'
      },
      {
        q: 'Šta znači „prvi put uveden program“?',
        a: 'Formalni program koji ranije nije postojao, potvrđen aktom, budžetskom linijom ili odlukom.'
      },
      {
        q: 'Kako se računa „broj partnerstava po glavi stanovnika“?',
        a: 'Broj partnerstava ÷ broj stanovnika × 1000. Npr. 3 ÷ 10000 × 1000 = 0.3.'
      },
      {
        q: 'Da li se boduju samo partnerstva sa privatnim sektorom?',
        a: 'Ne. Boduju se i partnerstva s NVO, međunarodnim organizacijama, univerzitetima itd.'
      },
      {
        q: 'Šta znači „novi e-servis“?',
        a: 'Servis koji nije postojao prethodne 2 godine (npr. mobilna aplikacija, online prijava kvarova).'
      },
      {
        q: 'Šta se smatra „dugoročnom održivošću projekta“?',
        a: 'Projekt ima plan održavanja i nastavlja se nakon početne faze, nije zavisan samo od granta.'
      },
      {
        q: 'Ko je odgovoran za tačnost unesenih podataka?',
        a: 'JLS potpisuje izjavu o tačnosti; netačni podaci mogu dovesti do diskvalifikacije.'
      },
      {
        q: 'Da li male JLS imaju šansu ako nemaju „velike brojke“?',
        a: 'Da. Model koristi relativne pokazatelje, što omogućava konkurentnost malim JLS.'
      }
    ]
  }
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Najčešća pitanja</h2>
      {faqData.map((category, catIdx) => (
        <div key={catIdx} style={{ marginBottom: '2rem' }}>
          <h3 style={{ borderBottom: '1px solid #ccc', paddingBottom: '0.5rem' }}>{category.category}</h3>
          {category.questions.map((item, idx) => (
            <div key={idx} style={{ marginTop: '1rem', border: '1px solid #e0e0e0', borderRadius: '6px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
              <div
                onClick={() => toggle(idx)}
                style={{ padding: '0.8rem 1rem', cursor: 'pointer', background: '#f9f9f9', fontWeight: 'bold' }}
              >
                {item.q}
              </div>
              {openIndex === idx && (
                <div style={{ padding: '1rem', background: '#fff' }}>
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
